module.exports = __webpack_public_path__ + "static/media/thruxton-wp.16165193.jpg";